import Color from '../Color.mjs'
import superMeta from '../_MODULE/metaModuleNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    codeProp: 'omNo',
    mapIdProp: 'orgMapId',
    mapStsCodeProp: 'orgMapStsCode',
    mapTypeCode: 'ORG_MAP',
    name: '组织域',
    ownerIdProp: 'oaId',
    ownerTextProp: 'oaName',
    ownerType: 'OA',
    textProp: 'omName',
    type: 'OM',
}
